import { OrdersTemplate } from "@/components/Templates";
import { useOrdersPage } from "@/hooks/useOrdersPage";

export function OrdersPage() {
  const ordersPage = useOrdersPage();

  return <OrdersTemplate {...ordersPage} />;
}
